import { useMutation } from '@apollo/client'
import ConfirmationModal from '@medical/components/ConfirmationModal'
import { MAX_FILE_SIZE } from '@medical/constant'
import { Formik } from 'formik'
import { Button } from 'primereact/button'
import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import { FileIcon, defaultStyles } from 'react-file-icon'
import * as Yup from 'yup'
import { GET_POST_PRE_SIGNED_URL } from '../UploadImage/UploadImage.graphql'
import { ProgressSpinner } from '@medical/components'
import { useCustom } from '@medical/provider/context'
import uploadImage from '@medical/libs/uploadImage'
import { PDFDocument } from "pdf-lib"

const UploadFileComponent = ({
  submitLabel,
  uploadFile,
  confirmationMessage,
  hideTitle,
}) => {
  const [{ i18n, popup }] = useCustom()
  const [loading, setLoading] = useState(false)
  const [filename, setFilename] = useState()
  const [getPostPreSignedUrl] = useMutation(GET_POST_PRE_SIGNED_URL)
  async function getPdfPageCount(file) {
    try {
      const arrayBuffer = await file.arrayBuffer()
      const pdfDoc = await PDFDocument.load(arrayBuffer)
      return pdfDoc.getPageCount()
    } catch (e) {
      console.log(e)
    }

    return 0
  }
  return (
    <Formik
      initialValues={{
        fileName: '',
        file: '',
        mimetype: '',
        confirm: false,
        isPdfError: '',
      }}
      onSubmit={uploadFile}
      validationSchema={Yup.object().shape({
        file: Yup.mixed().required(),
      })}
      render={formikProps => {
        const { setFieldValue, isValid,values } = formikProps
        return (
          <React.Fragment>
            {!hideTitle && (
              <div className='modal-title'>{i18n.t('main.uploadFile')}</div>
            )}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <Dropzone
                  onDrop={async files => {
                    if (files.length > 0) {
                      if (values.isPdfError !== '')
                        setFieldValue('isPdfError','')

                      setLoading(true)
                      const mineType = files[0].type;
                      const fileName = files[0].name;
                      if (mineType === 'application/pdf') {
                        const pages = await getPdfPageCount(files[0])
                        if (pages > 1) {
                          setLoading(false)
                          setFieldValue('isPdfError','1ページのPDFファイルをアップロードしてください。')
                          return
                        }
                      }

                      const {
                        data: postPreSignedUrl,
                      } = await getPostPreSignedUrl({
                        variables: {
                          fileName: fileName,
                          mimetype: mineType,
                        },
                      })

                      const key = await uploadImage(
                        i18n,
                        popup,
                        postPreSignedUrl,
                        files[0]
                      )
                      if (key) {
                        setFieldValue('file', key)
                        setFieldValue('filename',fileName)
                        setFieldValue('mimetype', mineType)
                        setFilename(fileName)
                      }
                      setLoading(false)
                    }
                  }}
                  maxSize={MAX_FILE_SIZE}
                  multiple={false}
                  accept={['image/jpeg', 'image/png', 'application/pdf']}
                >
                  {({ getRootProps, getInputProps }) => {
                    return (
                      <div {...getRootProps({ className: 'dropzone' })}>
                        <input {...getInputProps()} />
                        <p>{i18n.t('doctor.uploadFile.dropFileHere')}</p>
                        {filename && (
                          <>
                            <FileIcon
                              extension={filename.split('.').pop()}
                              {...defaultStyles[filename.split('.').pop()]}
                            />
                            {filename}
                          </>
                        )}
                      </div>
                    )
                  }}
                </Dropzone>
                <div className='modal-bottom'>
                  <div style={{textAlign: 'center'}}>
                    <div >
                      {values.isPdfError !== '' && <p style={{fontSize: '12px', color: '#db7093'}}>{values.isPdfError}</p>}
                    </div>

                    <Button
                      type='submit'
                      onClick={() => {
                        setFieldValue('confirm', true)
                      }}
                      disabled={!isValid}
                      label={submitLabel}
                    />
                  </div>
                </div>
              </>
            )}
            <ConfirmationModal
              {...formikProps}
              confirmationMessage={confirmationMessage}
            />
          </React.Fragment>
        )
      }}
    />
  )
}

export default UploadFileComponent
